<script setup lang="ts">
import { onMounted } from 'vue';

import { getDomain, performanceMark, importCSSFromUrl } from '@libs/utils';

import { usePreviouslyUserSessionStore } from './new-desktop/core/stores/previouslyUserSession/previouslyUserSessionStore';

const previouslyUserSessionStore = usePreviouslyUserSessionStore();
document.title = `${getDomain.getCurrentDomainSpec().Title}`;
importCSSFromUrl();

onMounted(() => {
  performanceMark('AppInitiated');
  previouslyUserSessionStore.loadPreviouslySeenHotels();
  previouslyUserSessionStore.cleanOldHotels();
});
</script>

<template>
  <router-view />
</template>
